import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    container: {
        flex: 1
    }
});
export default stylesheet;
